/**
 * [Phase 2c-D §6.2.1] Pure helper - translates a prior-league API row into the
 * wizard form shape. Lives in its own module (no React, no axios) so the
 * five-fixture round-trip test (§6.4) can import it under Jest without
 * dragging in the modal's network dependencies.
 *
 * Five §6.2.1 gotchas encapsulated here:
 *   (a) roster from settings.roster (never reconstructed from roster_size)
 *   (b) scoring rules hydrated via expandPreset(format, deltas)
 *   (c) UI tier (top/draftFormat/draftMode/seasonMode) from parseLeagueType
 *   (d) undefined league_type falls back to LIVE_DRAFT_LIVE_SEASON
 *   (e) UI-only keys never come from settings - only from parseLeagueType
 */
import { parseLeagueType } from "./Step1LeagueType";
import { expandPreset } from "./Step3Scoring";

export function parseCopiedSettings(league) {
  const settings = league.settings || {};
  const ui = parseLeagueType(league.league_type || settings.league_type);

  const roster = settings.roster || {
    qb: 1, rb: 2, wr: 2, te: 1, flex: 1, superflex: 0, k: 1, def: 1, bench: 5,
  };

  const scoring_rules = expandPreset(
    settings.scoring_format,
    settings.scoring_rules,
  );

  return {
    top: ui.top,
    // [Gotcha c continuation] league_type doesn't encode auction-vs-snake;
    // `settings.draft_format` is the source of truth. Fall back to ui's
    // auction default when not present.
    draftFormat: settings.draft_format || ui.draftFormat,
    draftMode: ui.draftMode,
    seasonMode: ui.seasonMode,
    name: "",
    commissioner_team_name: "",
    num_teams: settings.num_teams || 12,
    // [Item 1] Carry the season shape across a copy; default H2H for the
    // leagues created before this field existed.
    seasonLeagueType: settings.season_league_type || "h2h",
    roster,
    budget: settings.budget || 200,
    bidding_timer_seconds: settings.bidding_timer_seconds || 30,
    nomination_timer_seconds: settings.nomination_timer_seconds || 60,
    antisnipe_trigger_seconds: settings.antisnipe_trigger_seconds || 10,
    antisnipe_extend_seconds: settings.antisnipe_extend_seconds || 10,
    pick_timer_enabled: settings.pick_timer_enabled !== false,
    pick_timer_seconds: settings.pick_timer_seconds || 60,
    allow_pick_resubmit: settings.allow_pick_resubmit !== false,
    scoring_rules,
    use_keepers: false,
    nomination_order_mode: settings.nomination_order_mode || "lotto",
  };
}
